
import React from "react";
import { useTranslation } from "react-i18next";
import { Calendar, MapPin, ChevronRight } from "lucide-react";

const UpcomingEventsTab: React.FC = () => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  const upcomingEvents = [
    {
      id: 1,
      title: { ar: "مهرجان الرياض", en: "Riyadh Festival" },
      date: { ar: "15 مايو 2025", en: "May 15, 2025" },
      location: { ar: "الرياض", en: "Riyadh" },
      image: "https://images.unsplash.com/photo-1580913428706-c311e67898b3?q=80&w=2070&auto=format&fit=crop"
    },
    {
      id: 2,
      title: { ar: "معرض جدة الدولي", en: "Jeddah International Exhibition" },
      date: { ar: "22 يونيو 2025", en: "June 22, 2025" },
      location: { ar: "جدة", en: "Jeddah" },
      image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?q=80&w=1974&auto=format&fit=crop"
    },
    {
      id: 3,
      title: { ar: "موسم الدرعية", en: "Diriyah Season" },
      date: { ar: "10 يوليو 2025", en: "July 10, 2025" },
      location: { ar: "الدرعية", en: "Diriyah" },
      image: "https://images.unsplash.com/photo-1531058020387-3be344556be6?q=80&w=2070&auto=format&fit=crop"
    }
  ];

  return (
    <div className="space-y-6">
      {upcomingEvents.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {upcomingEvents.map((event) => (
            <div 
              key={event.id} 
              className="bg-white/[0.06] border border-white/[0.10] rounded-xl overflow-hidden hover:bg-white/[0.10] transition-all duration-300"
            >
              <div 
                className="h-40 bg-cover bg-center" 
                style={{ backgroundImage: `url(${event.image})` }}
              />
              <div className="p-4">
                <h3 className="font-medium text-base text-white">
                  {event.title[i18n.language as keyof typeof event.title]}
                </h3>
                <div className="flex flex-col space-y-2 mt-2">
                  <div className="flex items-center text-sm text-white/60">
                    <Calendar className="h-4 w-4 mr-2 text-primary-foreground" />
                    <span>{event.date[i18n.language as keyof typeof event.date]}</span>
                  </div>
                  <div className="flex items-center text-sm text-white/60">
                    <MapPin className="h-4 w-4 mr-2 text-primary-foreground" />
                    <span>{event.location[i18n.language as keyof typeof event.location]}</span>
                  </div>
                </div>
                <button className="mt-4 w-full flex items-center justify-center py-2 px-4 bg-primary/20 text-primary-foreground hover:bg-primary/30 rounded-md transition-colors">
                  <span className="text-sm font-medium">
                    {isRTL ? "عرض التفاصيل" : "View Details"}
                  </span>
                  <ChevronRight className="h-4 w-4 ml-1" />
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-10 text-center">
          <Calendar className="h-12 w-12 text-white/20 mb-3" />
          <p className="text-white/60 font-medium">
            {isRTL ? "لا توجد فعاليات قادمة حالياً" : "No upcoming events at the moment"}
          </p>
          <p className="text-white/40 text-sm mt-1">
            {isRTL ? "سيتم إضافة الفعاليات القادمة هنا قريباً" : "Upcoming events will be added here soon"}
          </p>
        </div>
      )}
    </div>
  );
};

export default UpcomingEventsTab;
